import { render } from "./BtnIcon.vue?vue&type=template&id=f446b8aa&scoped=true"
import script from "./BtnIcon.vue?vue&type=script&lang=js"
export * from "./BtnIcon.vue?vue&type=script&lang=js"

import "./BtnIcon.vue?vue&type=style&index=0&id=f446b8aa&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f446b8aa"]])

export default __exports__